module.exports = __webpack_public_path__ + "static/media/fz_verifydialogrobot_pt_BR.50c28dd8.png";